import {Component} from "react";

export class SellToWebTableColumnCheckboxV2Component extends Component {
} 